import Vue from 'vue'
import Router from 'vue-router'
import Login from "../components/Login/login.vue"
import ssoLogin from "../components/Login/ssoLogin.vue"
import Index from "../components/Index/Index.vue"
import controlBox from "../components/RightPane/controlBox.vue"
import qsPage from "../views/Questionnaire/qsPage.vue"
import defaultPage from "../views/Questionnaire/defaultPage.vue"
import orderReturnVisit from "../views/Sass/orderReturnVisit.vue"
import hotlineCall from "../views/Sass/HotlineCall/hotlineCall.vue"
import zzPage from "../components/Login/zzPage.vue"

let LoginIndex = Login

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: LoginIndex
    },
    {
      path: '/ssoLogin',
      name: 'ssoLogin',
      component: ssoLogin
    },
    {
      path: '/Index',
      name: 'Index',
      meta: {
        requireAuth: true  // 添加该字段，表示进入这个路由是需要登录的
      },
      component: Index
    },
    {
      path: '/controlBox',
      name: 'controlBox',
      component: controlBox
    },
    {
      path: '/qsPage',
      name: 'qsPage',
      component: qsPage
    },
    {
      path: '/defaultPage',
      name: 'defaultPage',
      component: defaultPage
    },
    {
      path: '/orderReturnVisit',
      name: 'orderReturnVisit',
      component: orderReturnVisit
    },
    {
      path: '/hotlineCall',
      name: 'hotlineCall',
      component: hotlineCall
    },
    {
      path: '/zzPage',
      name: 'zzPage',
      component: zzPage
    },
  ]
});
export const DynamicRoutes = []

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登录
router.beforeEach((to, from, next) => {
	let authToken = JSON.parse(LocalStorage.getItem('obj')) ? JSON.parse(LocalStorage.getItem('obj')).authToken : '';
  if(to.query.isHrWork){
    //是否润工作平台进来，不走缓存token
    LocalStorage.clear();
    SessionStorage.clear();
    //当前来源润工作 - 用来处理有部分软件无法自动登录
    LocalStorage.setItem('isHrWork', 1);
    authToken = '';
    next({
      path: '/zzPage' //跳转到空白中转页面
    })
  }
  
  //从单点登录重定向进入页面
  let token = to.query.token
  if (token) {
    authToken = 'Bearer ' + token
    let userObj = {
      userId: to.query.userId,
      userName: to.query.userName,
      workNo: to.query.workNo,
      vdnId: to.query.vdnId,
      authToken: authToken
    };
    LocalStorage.setItem("obj", JSON.stringify(userObj));
  }
  
	if(to.path === '/'){
		if (authToken) {
			next({
					path: '/Index'
			})
		}else{
			next();
		}

	}else{
		if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
			if (authToken) {
        next();
			}
			else {
        console.log('前端路由触发退出......');
        next({
          path: '/',
          query: to.query  // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
			}
		}else{
			next();
		}
  }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js